export enum HashOnly {
	merchant1 = "fhkj123",
	merchant2 = "GREEN",
	merchant3 = "BLUE",
}
